/* tslint:disable */
/* eslint-disable */
import { exists, mapValues } from '../runtime';
import {
    WarehouseInvoice,
    WarehouseInvoiceFromJSON,
    WarehouseInvoiceToJSON,
} from './WarehouseInvoice';

export interface WarehouseInvoiceLineItem {
    id?: number;
    invoiceId: number;
    packageId?: number;
    feeType: string;
    description?: string;
    quantity?: number;
    unitPrice: number;
    weight?: number;
    total: number;
    /**
     * Populated when the line item is fetched via an `include: 'invoice'` scope.
     * Lets consumers of the CourierPackage → warehouseInvoiceLineItems → invoice
     * chain read the parent invoice without an extra round trip.
     */
    invoice?: WarehouseInvoice;
}

export function instanceOfWarehouseInvoiceLineItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "invoiceId" in value;
    isInstance = isInstance && "feeType" in value;
    isInstance = isInstance && "unitPrice" in value;
    isInstance = isInstance && "total" in value;
    return isInstance;
}

export function WarehouseInvoiceLineItemFromJSON(json: any): WarehouseInvoiceLineItem {
    return WarehouseInvoiceLineItemFromJSONTyped(json, false);
}

export function WarehouseInvoiceLineItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseInvoiceLineItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'invoiceId': json['invoiceId'],
        'packageId': !exists(json, 'packageId') ? undefined : json['packageId'],
        'feeType': json['feeType'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'unitPrice': json['unitPrice'],
        'weight': !exists(json, 'weight') ? undefined : json['weight'],
        'total': json['total'],
        'invoice': !exists(json, 'invoice') ? undefined : WarehouseInvoiceFromJSON(json['invoice']),
    };
}

export function WarehouseInvoiceLineItemToJSON(value?: WarehouseInvoiceLineItem | null): any {
    if (value === undefined) { return undefined; }
    if (value === null) { return null; }
    return {
        'id': value.id,
        'invoiceId': value.invoiceId,
        'packageId': value.packageId,
        'feeType': value.feeType,
        'description': value.description,
        'quantity': value.quantity,
        'unitPrice': value.unitPrice,
        'weight': value.weight,
        'total': value.total,
        'invoice': WarehouseInvoiceToJSON(value.invoice),
    };
}
